import { addCopyToQuillHtml } from "@/constant/globalConstant";
import { setCurrentDashboard } from "@/redux/slices/dashboard.slice";
import { getColor } from "@/utils/colorSchemas";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import * as FaIcons from "react-icons/fa";
import { FiEdit } from "react-icons/fi";
import { MdDeleteForever } from "react-icons/md";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { v4 as uuid } from "uuid";
import TabModal from "./TabModal";

function DashboardTabs({ mode = "view", tabData, setTabData, setLayouts, setGridData, dashboard, setIframe, tabZoom = 1 }) {
  const dispatch = useDispatch();
  const [showTabModal, setShowTabModal] = useState(false);
  const [editTabData, setEditTabData] = useState();

  const tabCopyHandler = (id) => {
    // Swal.fire({
    //   title: "Are you sure?",
    //   text: "You want to make a copy of this tab?.",
    //   dangerMode: false,
    //   showCancelButton: true,
    //   confirmButtonText: "Confirm",
    // }).then((result) => {
    //   if (result.isConfirmed) {
    const selectedTab = tabData.find((i) => i.tabId === id);
    const finalName = addCopyToQuillHtml(selectedTab?.name || "");
    const newTab = {
      ...selectedTab,
      tabId: uuid(),
      isSelected: false,
      name: finalName,
    };
    delete newTab?._id;
    setTabData((pre) => [...pre, newTab]);
    //   }
    // });
  };

  const tabRemoveHandler = (tab) => {
    Swal.fire({
      title: "Delete Tab",
      text: "Do you wish to delete this tab?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Confirm",
    }).then((result) => {
      if (!result.isConfirmed) return;

      if (tabData.length === 1) {
        return Swal.fire({
          title: "At least one tab is required",
          icon: "warning",
          timer: 1500,
          confirmButtonText: "OK",
        });
      }

      // 1) remove tab (no mutation)
      const remaining = tabData.filter((i) => i.tabId !== tab.tabId);

      // 2) if removed tab was selected, select first remaining tab
      const nextTabs = tab.isSelected
        ? remaining.map((t, idx) => ({ ...t, isSelected: idx === 0 }))
        : remaining.map((t) => ({ ...t })); // ensures new objects (safe if frozen)

      setTabData(nextTabs);
    });
  };

  const tabSelectHandler = (tab) => {
    setTabData((pre) => pre.map((item) => ({ ...item, isSelected: item.tabId === tab.tabId })));
    setLayouts(tab.layouts || {});
    setGridData(tab.items || []);
    setIframe(tab.iframe || "");
    dispatch(setCurrentDashboard({ ...dashboard, items: tab.items, layouts: tab.layouts }));
  };

  const tabNumber = dashboard?.tabNumber || 4;

  return (
    <div className={`dashboard-tabs-wrapper ${tabNumber >= 7 ? "dashboard-tabs--dense" : ""}`}>

      <div className="dashboard-tabs-zoom-outer">
        <div
          className={`dashboard-tabs-zoom-inner ${tabZoom < 1 ? "dashboard-tabs--mobile-zoomed-out" : ""}`}
          style={{
            zoom: tabZoom,
            width: `calc(100% * ${tabZoom})`,
            minWidth: tabZoom > 1 ? `calc(100% * ${tabZoom})` : undefined,
          }}
        >
          <div
            className={`dashboard-tabs-grid dashboard-tabs--cols-${tabNumber} ${tabZoom < 1 ? "dashboard-tabs--mobile-2col" : ""} pt-1 pt-md-2`}
            style={{ "--tabs-in-row": tabNumber }}
          >
            {/* prev tabs */}
            {tabData?.map((tab) => (
              <div key={tab.tabId || tab._id} className="dashboard-tab-col">
                <div
                  className={`dashboardTab ${tab?.isSelected ? "active" : ""}`}
                  style={{
                    "--a": getColor(tab?.colorSchemeName, 0),
                    "--b": getColor(tab?.colorSchemeName, 1),
                    "--c": getColor(tab?.colorSchemeName, 2),
                  }}
                  onClick={() => tabSelectHandler(tab)}
                >
                  {mode !== "view" && (
                    <div className="editItems">
                      <div onClick={() => tabCopyHandler(tab.tabId)}>
                        <BiCopy className="me-2" />
                      </div>
                      <div
                        onClick={() => {
                          setEditTabData(tab);
                          setShowTabModal(true);
                        }}
                      >
                        <FiEdit className="me-1" />
                      </div>
                      {tabData.length > 1 && (
                        <div onClick={() => tabRemoveHandler(tab)}>
                          <MdDeleteForever className="fs-5" />
                        </div>
                      )}
                    </div>
                  )}

                  {/* <div className="text">{tab?.name}</div> */}
                  <div className="ql">
                    <div className="ql-editor p-0 pb-1 pe-2">
                      <div dangerouslySetInnerHTML={{ __html: tab?.name }}></div>
                    </div>
                  </div>
                  <div className="tabIcon mt-auto"> {React.createElement(FaIcons[tab?.icon])} </div>
                </div>
              </div>
            ))}
            {mode !== "view" && (
              <div className="dashboard-tab-col">
                <div onClick={() => setShowTabModal((p) => !p)} className="dashboardTab addTab">
                  +
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <TabModal
        {...{
          showTabModal,
          setShowTabModal,
          tabData,
          setTabData,
          editTabData,
          setEditTabData,
          setLayouts,
          setGridData,
        }}
      />
    </div>
  );
}

export default DashboardTabs;

DashboardTabs.propTypes = {
  mode: PropTypes.string,
  tabData: PropTypes.array,
  setTabData: PropTypes.func,
  setLayouts: PropTypes.func,
  setGridData: PropTypes.func,
  setIframe: PropTypes.func,
  dashboard: PropTypes.object,
  tabZoom: PropTypes.number,
};
